import { MENU_STACK, MenuStack } from '@angular/cdk/menu';
import { Directive } from '@angular/core';

/**
 * Gives every descendant `cdkMenuTrigger` its own independent {@link MenuStack}.
 *
 * `CdkContextMenuTrigger` (e.g. the app-wide right-click menu) provides a
 * `MENU_STACK` on its host, and CDK menu triggers resolve their stack with
 * `inject(MENU_STACK, { skipSelf: true, optional: true }) || new MenuStack()`.
 * That means a single context-menu trigger wrapping the app causes *every*
 * menu trigger underneath it to share one stack — so closing any one menu
 * makes every trigger on that stack re-focus itself (a focus cascade that
 * scrolls the nav). See SPA-746.
 *
 * Providing `MENU_STACK: null` here makes the descendants' `skipSelf` lookup
 * resolve to `null`, so each trigger falls back to creating its own stack —
 * the correct, isolated default — while the context-menu trigger keeps its own
 * stack. Apply this to a container that wraps the routed content but sits
 * inside the context-menu trigger.
 */
@Directive({
  selector: '[mdwIsolateMenuStacks]',
  providers: [{ provide: MENU_STACK, useValue: null }],
})
export class MdwIsolateMenuStacksDirective {}
